export default "__VITE_ASSET__CimlsnX7__"